import { http } from "../config.api.js"
// 危险源相关 API_Danger

export const listDangersForPM = (pageInfo, params) => { return http.get("/danger/selectDangersForPM/" + pageInfo, { urlParams: params }).then(res => res.data); };
export const projectListOfDangerRelease = (pageInfo, params) => { return http.get("/danger/projectListOfDangerRelease/" + pageInfo, { urlParams: params }).then(res => res.data); };
export const dangerListOfProject = (pageInfo, params) => { return http.get("/danger/dangerListOfProject/" + pageInfo, { urlParams: params }).then(res => res.data); };

export const dangerListByProject = params => { return http.get("/danger/dangerListByProject/", { urlParams: params }).then(res => res.data); };

export const removeDanger = params => { return http.post("/danger/removeDanger", params).then(res => res.data); };
export const dangerRelease = params => { return http.post("/danger/dangerRelease", params).then(res => res.data); };




// WEBPACK FOOTER //
// ./src/api/project/api_danger.js